import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";

export type CaseAssignmentsFilters = {
  startDate: string;
  endDate: string;
  teamId?: string;
  roleId?: string;
  userId?: string;
  litigation?: string;
  pageNumber: number;
  pageSize: number;
};
export type AssignmentGroup = {
  teamId: string | null;
  label: string;
  openMatters: number;
  preLitigationMatters: number;
  litigationMatters: number;
  averageOpenDays: string | null;
  newMatters: number;
  closedMatters: number;
  averageDaysToClose: string | null;
  demandsSent: number;
  demandConversionCohorts?: number | null;
  convertedDemandCohorts?: number | null;
  demandConversionRate?: string | null;
  acceptedOffers: number;
  acceptedAmount: string | null;
  averageAcceptedAmount: string | null;
  expectedFees: string | null;
  trustDeposits: string;
  trustWithdrawals: string;
  averageDaysToFirstDemand: string | null;
};
export type ClosedAssignmentMatter = {
  matterId: string;
  matterName: string | null;
  teams: string[];
  closedDate: string;
  acceptedAmount: string | null;
  expenseCost: string;
  expectedFees: string | null;
  demands: number;
  demandConversionCohorts?: number | null;
  convertedDemandCohorts?: number | null;
  demandConversionRate?: string | null;
  acceptedOffers: number;
  daysToClose: number | null;
};
export type AssignmentOption = { id: string; label: string };
export type CaseAssignmentsResponse = {
  data: {
    groups: AssignmentGroup[];
    totals: AssignmentGroup;
    closedMatters: ClosedAssignmentMatter[];
    totalClosedMatters: number;
    teams: AssignmentOption[];
    roles: AssignmentOption[];
    users: AssignmentOption[];
    statusCategories: AssignmentOption[];
    freshness: {
      oldestProjectionAt: string | null;
      pendingMatters: number;
      missingMatters: number;
      ready: boolean;
    };
  };
  pagination: { pageNumber: number; pageSize: number; hasMore: boolean };
};
export async function retrieveCaseAssignments(
  filters: CaseAssignmentsFilters,
  signal?: AbortSignal,
) {
  const response =
    await authenticatedFastApiAxiosInstance.post<CaseAssignmentsResponse>(
      "reports/v2/case-assignments/query",
      filters,
      { signal },
    );
  return response.data;
}
